import numberInput from './num.js'

// 自定义指令
const directives = {
  numberInput
};

export default {
  install(Vue) {
    Object.keys(directives).forEach((key) => {
      Vue.directive(key, directives[key])
    })
  },
}



// WEBPACK FOOTER //
// ./src/directives/index.js